import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateRangeFilterComponent} from './date-range-filter.component';
import {BrowserModule} from "@angular/platform-browser";
import {ModalModule} from "ngx-bootstrap/modal";
import {DateRangePickerPopoverModule} from "../date-range-picker-popover/date-range-picker-popover.module";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [DateRangeFilterComponent],
  imports: [
    CommonModule,
    BrowserModule,
    ModalModule,
    DateRangePickerPopoverModule,
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule
  ],
  exports: [DateRangeFilterComponent]
})
export class DateRangeFilterModule { }
